import React from 'react';
import SwatchDetails from './swatch-details';
import { MetricsElement } from "react-metrics";

import '../../css/swatch-group.less';

export const Swatch = ({swatch, swatchClass, selectSwatch, buttonClass, swatchProps}) => {
	const validateSwatchSelection = (swatch) => {
		if(swatch.disabled){
			return null;
		}
		return selectSwatch(swatch);
	}
	const {type, displayName, value, variants, flag, disabled=false} = swatch;
	switch(type) {
    case "color-hex":
		return(
			<div key={value} className={`swatch color-picker-swatch ${swatchClass}`}>
				<button 
					onClick={()=>validateSwatchSelection(swatch)} 
					className={`color-picker-swatch-dot${disabled ? ' disabled': ''}${buttonClass ? ' '+buttonClass : ''} unstyled`} 
					style={{backgroundColor: value}} 
					title={ displayName }
					{...swatchProps || {}}
				/>
			</div>
		)
	case "size":
		return(
			<div key={value} className={`swatch size-swatch ${swatchClass}`}>
				<button onClick={()=>validateSwatchSelection(swatch)} className={`size-swatch-element${disabled ? ' disabled': ''} unstyled`} title={ displayName }>
					<p className='size-label'>{displayName}</p>
				</button>
			</div>
		)
    default:
        return(
			<div key={value} className={`swatch default-swatch ${swatchClass}`}>
				<button onClick={()=>validateSwatchSelection(swatch)} className={`default-swatch-element${disabled ? ' disabled': ''} unstyled`} title={ displayName }>
					<p className='default-label'>{displayName}</p>
				</button>
			</div>
		)
	}
}

export class SwatchGroup extends React.Component {

	selectSwatch = (selectedSwatch) => this.props.selectSwatch(this.props.swatchGroup.key, selectedSwatch, this.props.level);

	createTextHeader = () => {
		if(this.props.selectedSwatch.hasOwnProperty('displayName')){
			return this.props.selectedSwatch.displayName;
		}
		const { swatchGroup } = this.props;
		const key = swatchGroup.displayName[0].toLowerCase();
		const vowels = {'a':1, 'e':1, 'i':1, 'o':1, 'u':1};
		return `Please select ${vowels[key] ? "an" : "a"} ${swatchGroup.displayName.toLowerCase()}`;
	}

	render(){
		const { selectedSwatch, selectedProp, swatchGroup, className } = this.props;
		const value = swatchGroup.values[0].value;
		const selectionText = this.createTextHeader();
		const matchValue = selectedProp || "value"
		
		return (
			<div className='swatch-group'>
					<div className="swatch-group-header">
						{swatchGroup.displayName}: <span className='swatch-selection'>{selectionText}</span>
					</div>
					<div className={`swatches ${swatchGroup.key}-swatches`}>
						{
							swatchGroup.values.map((s,index) =>
								s.flag === "show" ?
								<MetricsElement
								  element="span"
								  key={`${s.key}-${index}`}
								  data-metrics-event-name="linkClick"
								  data-metrics-event="e_linkClick"
								  data-metrics-link-id={`${s.type}:${s.displayName}`}
								 >
									<Swatch
										swatch={s}
										selectSwatch={this.selectSwatch}
										swatchClass={s[matchValue] === selectedSwatch[matchValue] ? 'selected' : ''}
									/>
								 </MetricsElement>
								 : null
							)
						}
					</div>
					<SwatchDetails type={swatchGroup.key} value={value}/>
			</div>
		)
	}
}
